var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.82267C13 3.68699 11.2091 1.95567 9 1.95567C6.79086 1.95567 5 3.68699 5 5.82267C5 7.95835 6.79086 9.68967 9 9.68967C11.2091 9.68967 13 7.95835 13 5.82267ZM7 5.82267C7 4.75483 7.89543 3.88917 9 3.88917C10.1046 3.88917 11 4.75483 11 5.82267C11 6.89051 10.1046 7.75617 9 7.75617C7.89543 7.75617 7 6.89051 7 5.82267ZM9 10.6564C11.67 10.6564 17 11.9422 17 14.5234V17.4237H1V14.5234C1 11.9422 6.33 10.6564 9 10.6564ZM2.9 14.5234C2.9 13.9047 6.03 12.4932 9 12.4932C11.97 12.4932 15.1 13.9047 15.1 14.5234V15.5868H2.9V14.5234Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.82267C13 3.68699 11.2091 1.95567 9 1.95567C6.79086 1.95567 5 3.68699 5 5.82267C5 7.95835 6.79086 9.68967 9 9.68967C11.2091 9.68967 13 7.95835 13 5.82267ZM7 5.82267C7 4.75483 7.89543 3.88917 9 3.88917C10.1046 3.88917 11 4.75483 11 5.82267C11 6.89051 10.1046 7.75617 9 7.75617C7.89543 7.75617 7 6.89051 7 5.82267ZM9 10.6564C11.67 10.6564 17 11.9422 17 14.5234V17.4237H1V14.5234C1 11.9422 6.33 10.6564 9 10.6564ZM2.9 14.5234C2.9 13.9047 6.03 12.4932 9 12.4932C11.97 12.4932 15.1 13.9047 15.1 14.5234V15.5868H2.9V14.5234Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.988922,
    width: 18,
    height: 17.4015,
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.7f6dcd3abd6e98408457a3d7508c540c.svg";
export { ForwardRef as ReactComponent };